import React, { Component } from 'react';

interface IProps {
    gtmEvent(): void;
    name: string;
}

export class TerminatorInvite extends Component<IProps, any> {

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    render() {

        return (
            <header className="App-header">
                <h1 className='l'><span className='doddltext'>Thanks, {this.props.name}</span></h1>
                <div className='wrapper'>
                    <div className='row'>
                    <h1 className='l'>We will also send you an invite<br/>to our secure portal</h1>
                    </div>
                    <div className='row pt-2'>
                        <div className='btn-primary' onClick={() => window.location.href='/'}>Close</div>
                    </div>
                </div>
            </header>
        );
    }
}
